import React from 'react'
import styled from 'styled-components'

import { SearchSelect } from '../../../input'
import { FONTS } from '../../../../constants'
import { _levels } from '../../types'

export const CompanyInfoSecondCol = props => {
  const {
    movementData,
    _divisions,
    _teams,
    handleInput,
  } = props

  const division = _divisions.find(e => e._id === movementData.division_id) || null
  const team = _teams.find(e => e._id === movementData.team_id) || null
  const level = _levels.find(l => l.value === movementData.level) || null

  return (
    <FormWrapper>
      <FormGroup>
        <LabelCol>
          <Label>Division</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='division_id'
            placeholder='Select Division'
            value={ division }
            options={ _divisions }
            onChange={ e => handleInput(e, 'division_id') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Team</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='team_id'
            placeholder='Select Team'
            value={ team }
            options={ _teams }
            onChange={ e => handleInput(e, 'team_id') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Level</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='level'
            placeholder='Select Level'
            value={ level }
            options={ _levels }
            onChange={ e => handleInput(e, 'level') }
          />
        </InputCol>
      </FormGroup>
    </FormWrapper>
  )
}

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    :nth-child(1) {
        padding-right: 6px;
    }

    :nth-last-child(1) {
        padding-left: 6px;
    }
`

const FormGroup = styled.div`
    display: flex;
    margin-bottom: 16px;
`

const LabelCol = styled.div`
    display: flex;
    flex: 1;
`

const InputCol = styled.div`
    display: flex;
    flex: 2;

    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/movement/create-movement/second-column.js